import { apiUrls } from 'constants/apiUrls';
import { ApiBase } from './API';
import { IDataProviderService, FilterRequest, MapDataRequest, MapGeoJsonDataResult } from 'types/types';
import { AxiosRequestConfig } from 'axios';

class DataProviderService extends ApiBase implements IDataProviderService {
  constructor() {
    super('');
  }

  public getDashboardDescriptor = async (dashboardId: string): Promise<any> => {
    return this.instance.get<any>(
      `${apiUrls.getDashboardDescriptorUrl}?dashboardId=${dashboardId}`
    );
  };

  public getData = async (requestData: any, config?: AxiosRequestConfig): Promise<any> => {
    return this.instance.post<any>(apiUrls.getDataUrl, requestData, config);
  };

  public getFilterData = async (filterRequest: FilterRequest): Promise<any> => {
    return this.instance.post<any>(apiUrls.getFilterDataUrl, filterRequest);
  };

  public getAdvancedMapData = async (filterRequest: MapDataRequest): Promise<any> => {
    return this.instance.post<any>(apiUrls.advancedMapData, filterRequest);
  };

  public getAdvancedMapDataFilters = async (filterRequest: MapDataRequest): Promise<any> => {
    return this.instance.post<any>(apiUrls.globalFiltersListData, filterRequest);
  };

  public getMapGeoJsonData = async (filterRequest: MapDataRequest, config?: AxiosRequestConfig): Promise<MapGeoJsonDataResult> => {
    return this.instance.post<MapGeoJsonDataResult>(apiUrls.getMapGeoJsonData, filterRequest, config);
  };
}

export default DataProviderService;
